var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    fill: "none",
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 0.333,
    y: 0.855,
    fill: "#fff",
    fillOpacity: 0.08,
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B9300",
    d: "M33.565 46.68H47.02v7.276H33.565zm0-7.244H47.02v7.244H33.565z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#self-service_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.905 37.281H31.762a.36.36 0 0 0-.357.358v17.946c0 .196.16.357.357.357h17.143c.196 0 .357-.16.357-.357V37.639a.36.36 0 0 0-.357-.358M34.262 40.14h12.143v5.223H34.262zm12.143 12.946H34.262v-5.223h12.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.405 50.758a1.429 1.429 0 1 0 2.857 0 1.429 1.429 0 0 0-2.857 0m0-7.946a1.429 1.429 0 1 0 2.857 0 1.429 1.429 0 0 0-2.857 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7 33.842c-2.045-5.397-7.255-9.236-13.358-9.236S29.03 28.44 26.985 33.838a8.945 8.945 0 0 0-6.652 8.696c.027 4.66 3.643 8.45 8.197 8.857a.36.36 0 0 0 .388-.357v-2.696a.36.36 0 0 0-.312-.353 5.57 5.57 0 0 1-3.22-1.54 5.5 5.5 0 0 1-1.66-3.956c0-1.25.406-2.428 1.17-3.41a5.56 5.56 0 0 1 2.95-1.951l1.692-.447.621-1.638a11 11 0 0 1 3.933-5.067 10.8 10.8 0 0 1 6.25-1.973c2.255 0 4.415.683 6.25 1.977a10.9 10.9 0 0 1 2.34 2.233 10.8 10.8 0 0 1 1.593 2.834l.616 1.634 1.688.447a5.544 5.544 0 0 1 4.111 5.357c0 1.5-.589 2.906-1.66 3.955a5.56 5.56 0 0 1-3.21 1.54.353.353 0 0 0-.308.353v2.701c0 .21.183.375.393.357 4.54-.41 8.147-4.196 8.178-8.848a8.94 8.94 0 0 0-6.634-8.7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "self-service_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.333 20.23h40v40h-40z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfService);
export default __webpack_public_path__ + "static/media/self-service.160134c555065b18833e2644fc6f1cf0.svg";
export { ForwardRef as ReactComponent };